var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26575 6.50131C1.34915 5.83407 1.91636 5.33335 2.58879 5.33335L6.78131 5.33335C7.31175 5.33335 7.82046 5.54406 8.19553 5.91914L10.3598 8.08349C10.5794 8.30304 10.8471 8.46847 11.1416 8.56665L11.505 8.68778L13.3252 9.05178C14.493 9.28533 15.3336 10.3107 15.3336 11.5017C15.3336 12.8815 14.215 14 12.8352 14L12.3123 14L12.3091 14C11.0735 13.9941 9.21138 13.9955 7.50764 13.9977C7.19971 13.9981 6.89687 13.9985 6.60382 13.9989C5.27798 14.0008 4.15263 14.0023 3.66373 14C2.97468 13.9967 2.23897 13.8283 1.65741 13.3969C1.04909 12.9456 0.666991 12.2464 0.666992 11.3333C0.666992 11.3056 0.668711 11.278 0.67214 11.2506L1.26575 6.50131ZM2.00071 11.3718C2.01021 11.8498 2.19737 12.1373 2.4518 12.3261C2.73976 12.5397 3.1707 12.6643 3.67016 12.6667C4.15452 12.669 5.27391 12.6674 6.59987 12.6656C6.89332 12.6652 7.19688 12.6647 7.50592 12.6643C9.20798 12.6621 11.0734 12.6607 12.3139 12.6667L12.3155 12.6667L12.8352 12.6667C13.4786 12.6667 14.0002 12.1451 14.0003 11.5017C14.0003 10.9463 13.6083 10.4681 13.0637 10.3592L11.2028 9.98709C11.1757 9.98167 11.149 9.97457 11.1228 9.96582L10.72 9.83157C10.229 9.66792 9.78295 9.39222 9.41703 9.02629L7.25272 6.86195C7.12769 6.73692 6.95812 6.66668 6.78131 6.66668L2.58879 6.66668L2.00071 11.3718Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2903 8.34999C10.5506 8.61033 10.5506 9.03244 10.2903 9.29279L8.87607 10.707C8.61572 10.9674 8.19361 10.9674 7.93326 10.707C7.67291 10.4467 7.67291 10.0245 7.93326 9.7642L9.34748 8.34999C9.60783 8.08964 10.0299 8.08964 10.2903 8.34999Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87606 6.93574C9.13641 7.19609 9.13641 7.6182 8.87606 7.87855L6.99044 9.76417C6.73009 10.0245 6.30798 10.0245 6.04763 9.76417C5.78728 9.50382 5.78728 9.08171 6.04763 8.82136L7.93325 6.93574C8.1936 6.67539 8.61571 6.67539 8.87606 6.93574Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66695 2C3.03514 2 3.33361 2.29848 3.33361 2.66667V6C3.33361 6.36819 3.03514 6.66667 2.66695 6.66667C2.29876 6.66667 2.00028 6.36819 2.00028 6V2.66667C2.00028 2.29848 2.29876 2 2.66695 2Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66695 2C7.03514 2 7.33361 2.29848 7.33361 2.66667V6C7.33361 6.36819 7.03514 6.66667 6.66695 6.66667C6.29876 6.66667 6.00028 6.36819 6.00028 6V2.66667C6.00028 2.29848 6.29876 2 6.66695 2Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootWhiteIcon);
export default __webpack_public_path__ + "static/media/bootWhiteIcon.7b0e45c3930523832ca394abbb6c34b1.svg";
export { ForwardRef as ReactComponent };